import script from "./ProductsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductsView.vue?vue&type=script&setup=true&lang=ts"

import "./ProductsView.vue?vue&type=style&index=0&id=4fb884b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fb884b8"]])

export default __exports__